//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Classification of Wildberries products and warehouses by dimensions and weight. */
export enum WbCargoType {
  /** МГТ - Малогабаритный товар (Small cargo). */
  Small = 1,
  /** СГТ - Сверхгабаритный товар (Extra large cargo). */
  ExtraLarge = 2,
  /** КГТ+ - Крупногабаритный товар (Large cargo). */
  LargePlus = 3
}
